// extracted by mini-css-extract-plugin
module.exports = {"divider":"FollowerOfficeCountSection_divider__RcX5Z"};